// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"calendar-edit"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15.0008 22.5L15 19.7866L19.2866 15.5L22 18.2134L17.7134 22.5H15.0008Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 10V21H11M3 10H21M3 10V5H21V10M21 10V12M7 5V2M17 5V2","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17.2006 17.586L15 19.7866L15.0008 22.5H17.7134L19.914 20.2994M17.2006 17.586L19.2866 15.5L22 18.2134L19.914 20.2994M17.2006 17.586L19.914 20.2994","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CalendarEditIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'calendar-edit',
    ref,
    icon: element,
  },
));

CalendarEditIcon.displayName = 'CalendarEditIcon';

export default CalendarEditIcon;
